if ( pplang == 'pt') {


    //Notices =
    var locale = 'pt';
    var helpurl = 'https://ultrapassport.com/ajuda/';
    var _lwidth = '3em';


    var _globalnotice = `Os Ingressos para o ${regname} estarão à venda amanha`;
    var _globalnoticereg = 'Confira seu email! Nós mandamos as intruções de compra do ingresso.';
    var _maintenance = 'Ultra Passport está indisponível no momento, tente novamente mais tarde.';
    var _guestnotice = 'É necessário estar logado para ver está página.';

    //Labels =
    var _fullname = 'Nome Completo';
    var _firstname = 'Primeiro Nome';
    var _lastname = 'Sobrenome';
    var _email = 'Email';
    var _emailaddy = 'Endereço de email';
    var _confirmemailaddy = 'Confirm Email Address';
    var _birthday = 'Data de Nascimento';
    var _location = 'Local de Nascimento';
    var _country = 'País';
    var _homeevent = 'Evento de seu interesse';
    var _gender = 'Sexo';
    var _password = 'Senha';
    var _male = 'Masculino';
    var _female = 'Feminino';
    var _pleaseselect = 'Selecione';
    var _signuptitle = 'Ultra Passport Cadastro';
    var _enteryouremail = 'Preencha seu endereço de Email';
    var _backtologin = 'Entrar Novamente';
    var _requestnewpass = 'Solicitar Troca de Senha';
    var _on = 'Ligado';
    var _off = 'Desligado';
    var _enrollmentavailable = 'Inscrições disponíveis agora';

    //Text =
    var _logintext = 'Entrar';
    var _password = 'Senha';
    var _welcome = 'Bem-Vindo';
    var _account = 'Conta';
    var _myaccount = 'Minha Conta';
    var _mypassport = 'Minha Passport';
    var _events = 'Eventos';
    var _points = 'Pontos';
    var _updates = 'Updates';
    var _signout = 'Sair';
    var _signin = 'Entrar';
    var _signedin = 'Assinado';
    var _signuptext = 'Cadastrar-se';
    var _nextlevel = 'Proximo nível';
    var _forgot = 'Esqueceu sua senha?';
    var _subscribed = 'Inscrito';
    var _helpcenter = 'Centro de ajuda';
    var _error = 'Erro';
    var _silver = 'Prata';
    var _gold = 'Ouro';
    var _platinum = 'Platinum';

    //Validation =
    var _gendertext = 'É necessário escolher um sexo';
    var _accepttext = 'É necessário aceitar os termos';


    //Email Verifications =
    var _resendverify = 'Reenviar confirmação de email';
    var _revalidate = 'Cheque seu email para validar sua conta';
    var _sendingverification = 'Enviando verificação de email...';
    var _verifysent = 'Verificação enviada';
    var _emailverifydashboard = 'Não esqueça de confimar seu email para ter acesso a updates e cadastro de ingressos';
    var _emailverifyupdates = 'Não esqueça de confirmar seu email para receber updates';


    //Edit =
    var _editaccount = 'Editar Conta';
    var _nochanges = 'Nenhuma edição detectada';
    var _accountupdated = 'Conta atualizada';
    var _emailupdatedstarted = 'Novo email precisa ser verificado, confira seu email.';
    var _emailupdatedverified = 'Seu novo email esta verificado';
    var _passwordresetsent = 'Email para troca de senha enviado';


    //Footer =
    var _startinput = 'Preencha seu email para começar...';
    var _starttext = 'Não tem uma conta? Cadastre-se para estar elegível <br class ="small-hide">à eventos, pontos e mais!';
    var _getstarted = 'Comece Aqui';


    //Signup =
    var _createaccount = 'Criar Minha Conta';
    var _almost = 'Quase Lá...';
    var _almost2 = 'Parabéns $user_firstname, você criou sua conta Ultra Passport! <span class="tm">™</span>';
    var _almost3 = 'Para ativar sua conta <strong><u>é ncessário verificar seu email</u></strong> clicando no link de confirmação que enviamos ao seu <strong>$user_email</strong>..';
    var _almost4 = 'Caso não tenha recebido nenhum email <strong><u>confira sua pasta de spam</u></strong> e inclua <strong><u><a href="mailto:info@e.ultrapassport.com">info@e.ultrapassport.com</a></u></strong> a seus <strong><u>contatos confiavéis</u></strong>';
    var _almost5 = 'Prosseguir';
    var _createdsuccess = 'Conta Criada';
    var _createdinfo = 'Sua Conta esta sendo criada:';
    var _accountactivated = 'Sua Conta foi ativada';
    var _accountverified = 'Seu email foi verificado.';
    var _passwordresetsuccess = 'Troca de Senha com sucesso';


    //Updates =
    var _updatestext1 = 'É necessário entrar para se registrar e receber updates.';
    var _updatestextPending = 'Por favor verifique seu endereço de email para receber updates.';
    var _updatessubsrcibe = 'Você está inscrito para receber updates do:';
    var _updatesunsubsrcibe = 'Você cancelou a inscrição para receber updates do:';


    //Registration =
    var _rbtnbuy = 'Compre Ingressos agora';
    var _regbuy = 'Compre Ingressos';
    var _rbtnregister = 'Registro para Ingressos';
    var _rbtnclosed = 'Fechado';
    var _rbtnsoon = 'Em Breve';
    var _rbtnupdates = 'Receber Updates';
    var _verifyemailregister = 'É necessário verificar seu email antes de se registrar';
    var _regbtnhtml = 'Registrado';
    var _regerror = 'Erro!';
    var _regerror2 = 'Por favor tente novamente';
    var _regprocessing = 'Seu Registro está sendo processado...';
    var _registersuccess = 'Registro feito com sucesso.';
    var _regaccepted = 'Seu <u class="regtype"></u> registro foi aceito no';
    var _regaccepted2 = 'Instruções de compra são enviadas ao seu email entra 24-48 horas antes do início das vendas.';
    var _regdone1 = 'Código de registro';
    var _regdone2 = 'Você se registrou em';
    var _regdone3 = 'Reenviar instruções de compra';

    //Registrations =
    var _regtext1 = 'Suas Informações estão atualizadas?';
    var _regtext2 = 'Por Favor confirme sua informação de registro para';
    var _regguest1 = 'É necessario estar logado para registrar à eventos';
    var _regpending1 = 'Quase lá!';
    var _regpending2 = 'Por favor confirme sua <strong>conta de email</strong> para liberar o cadastro.';
    var _updateinfobtn = 'Atualizar Minhas Informações';
    var _confirmreg = 'Confirme Meu Registro';


    // Privacy / Terms Notice =
    var privacytext = 'Política de Privacidade';
    var termsofuse = 'Termos de Uso';
    var upptextlogo = 'Ultra Passport<span class="tm">&trade;</span>';
    var privacylink = `<a href="https://ultrapassport.com/privacy-policy" target="_blank">${privacytext}</a>`;
    var termslink = `<a href="https://ultrapassport.com/terms-of-use" target="_blank">${termsofuse}</a>`;
    var _agreesignup = `Eu concordo com os ${termslink} e a ${privacylink} no ${upptextlogo}`;
    var _agreesignup2 = `Ao Cadastrar, você concorda com os ${termslink} e a ${privacylink} do ${upptextlogo}`;
    var _agreeregister = `Ao Registrar, você concorda com os ${termslink} e a ${privacylink} do ${upptextlogo}`;


  // Passport Labels
    _action = 'Ação',
    _award = 'Prêmio',
    _benefit = 'Benefício',
    _pointsexpire = '*OS PONTOS EXPIRAM APÓS 25 MESES ',
    _qualifydisclaimer = '*ATENÇÃO O "FULL ULTRA FESTIVAL" NÃO INCLUI O ROAD TO ULTRA, ULTRA BEACH E OS EVENTOS RESISTANCE.',

    _howtoqualify = 'Como se Registrar',

    _btn_dashboard = 'Página Inicial',
    _btn_benefits = 'Benefícios',
    _btn_qualify = 'Registre-se',
    _btn_points = 'Meus Pontos',

    leveltext = _silver,
    nextlevel = _gold;



    // Errors =
    var errors = {
        reset : 'Email inválido ou token expirado.',
        create : 'Criação sem sucesso, por favor tente novamente.',
        general : 'Oops! Algo deu errado. Por favor confira se os cookies estçao permitidos.',
        password : 'Senha deve conter no mínimo 8 caracteres.',
        duplicateemail : 'Conta de email já está em uso.',
        matchemail : 'Your email addresses don\'t match. Please confirm and reenter your email address.',
        loginfail : 'O nome de usuário e a senha digitados não correspondem aos nossos registros.',
        token : 'Token Inválido',
        birthday : "You must be 18 years of age or older to enroll in Ultra Passport.",
    }

    // Point Labels
    var pointcodes = {
        manual : 'Passport Admin',
        unknown : 'Ajuste del Administrador de Pasaportes',
        verify : 'Conta de Email Verificada',
        attend_festival : 'Vá ao Full Ultra Festival',
        attend_rtu : 'Attend a Road to Ultra Event',
        attend_resistance : 'Attend a Resistance Only Event',
        away_bonus : 'Vá a um Evento em Outro Continente',
        home_bonus_1 : 'Vá ao Evento no seu País',
        home_bonus_2 : 'Vá ao Evento no seu País x2',
        home_bonus_3 : 'Vá ao Evento no seu País x3'
    };

}
